import translate from "@/i18n/translate";
import { useIntl } from "react-intl";
import { OutcomesTerminology } from "@/contexts/AppContext";
import { useFormatMessage } from "@/features/common/helper";

interface CoursesTableProps {
  outcomesTerminology?: OutcomesTerminology | null;
}

export default function CoursesTable({ outcomesTerminology }: CoursesTableProps) {
  const formatMessage = useFormatMessage();
  const learningOutcomesLabel = formatMessage(
    { id: "app.orgProgressCard.learningOutcomes" },
    { learning_outcome_plural: outcomesTerminology?.learningOutcomes?.plural || "..." }
  );
  
  return (
    <Table>
      <TableHeader
        columns={[
          translate("app.missionAndOutcomes.course"),
          learningOutcomesLabel,
          translate("app.orgProgressCard.ILOMapped"),
          translate("app.drilldown.lead")
        ]}
      />
      <TableBody />
    </Table>
  );
}

const Table = (props: any) => {
  return <table className="data-table -shadow">{props.children}</table>;
};
const TableHeader = (props: any) => {
  return (
    <thead className="dataheader">
      <tr className="dataheaderrow">
        {props.columns.map((column: string, index: number) => {
          return (
            <th
              className="dataheadercell"
              data-th={column}
              key={`column-${index}`}
            >
              {column}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

const TableBody = (props: any) => {
  return (
    <tbody className="databody">
      <tr>
        <td colSpan={4} className="table-row">
          {translate("app.missionAndOutcomes.coursesComingSoon")}
        </td>
      </tr>
    </tbody>
  );
};
